import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const TriggerNode = memo((props: NodeProps) => {
  const getDescription = () => {
    const config = props.data.config;

    if (!config) {
      return 'Click to configure';
    }

    const parts = [];

    // Tipo de início
    if (config.scheduleType === 'scheduled') {
      parts.push('📅 Scheduled');
    } else {
      parts.push('⚡ Immediate');
    }

    // Número de conexões
    if (config.connections?.length) {
      parts.push(`${config.connections.length} connection(s)`);
    } else {
      parts.push('⚠️ No connections');
    }

    // Número de categorias
    if (config.categories?.length) {
      parts.push(`${config.categories.length} category(ies)`);
    } else {
      parts.push('⚠️ No categories');
    }

    return parts.join(' • ');
  };

  return (
    <BaseNode
      {...props}
      icon="⚡"
      label="Trigger"
      color="#8ad0f3"
      description={getDescription()}
      onDelete={props.data.onDelete}
    />
  );
});

TriggerNode.displayName = 'TriggerNode';
